import * as THREE from 'three';
import { Vector3 } from "three";

// Initialiser avec un aspect ratio de 1 (sera mis à jour dynamiquement)
const aspect: number = 1;

// Caméra orthographique (vue de haut par défaut)
const camera = new THREE.OrthographicCamera(
	-20 * aspect, 20 * aspect,
	20, -20,
	0.1, 250
);

camera.position.set(0, 30, 0);
camera.lookAt(0, 0, 0);
camera.up.set(0, 0, -1); // X horizontal, Z vertical
camera.layers.enable(1);

// Variable globale de vue
let isIsoView: boolean = false;

// Vue de haut
const topView = {
	position: new THREE.Vector3(0, 30, 0),
	lookAt: new THREE.Vector3(0, 0, 0),
	up: new THREE.Vector3(0, 0, -1),
};

// Vue isométrique
const isoView = {
	position: new THREE.Vector3(30, 30, 30),
	lookAt: new THREE.Vector3(0, 0, 0),
	up: new THREE.Vector3(0, 1, 0)
};

// Variables pour la transition
let transitionProgress: number = 1;
const transitionSpeed = 0.01;

// Fonction pour mettre à jour les dimensions de la caméra
function updateCameraAspect(width: number, height: number): void {
	const aspect = width / height;

	// Maintenir la hauteur constante et ajuster la largeur
	const frustumHeight = Math.abs(camera.top - camera.bottom);
	const halfFrustumWidth = (frustumHeight * aspect) / 2;

	camera.left = -halfFrustumWidth;
	camera.right = halfFrustumWidth;
	camera.updateProjectionMatrix();
}

// Bascule
function switchCameraView(): void {
	isIsoView = !isIsoView;
	transitionProgress = 0;
}

// Animation
function updateCameraTransition(): void {
	if (transitionProgress < 1) {
		transitionProgress += transitionSpeed;

		const startPos: Vector3 = isIsoView ? topView.position : isoView.position;
		const endPos: Vector3 = isIsoView ? isoView.position : topView.position;
		const startLook: Vector3 = isIsoView ? topView.lookAt : isoView.lookAt;
		const endLook: Vector3 = isIsoView ? isoView.lookAt : topView.lookAt;
		const startUp: Vector3 = isIsoView ? topView.up : isoView.up;
		const endUp: Vector3 = isIsoView ? isoView.up : topView.up;

		camera.position.lerpVectors(startPos, endPos, transitionProgress);
		const lookAt: Vector3 = new THREE.Vector3().lerpVectors(startLook, endLook, transitionProgress);
		const upVector: Vector3 = new THREE.Vector3().lerpVectors(startUp, endUp, transitionProgress);

		camera.lookAt(lookAt);
		camera.up.copy(upVector);
	}
}

export function getZoomPercentage(): number {
	const zoom = camera.zoom;
	if (zoom <= 1) {
		return 5 + (zoom - 0.5) * (95 / 0.5); // de 5% à 100%
	} else {
		return 100 + (zoom - 1) * (100); // de 100% à 200%
	}
}

export function onZoomOut(): void {
	if (camera.zoom >= 0.5) {
		if (camera.zoom <= 1) {
			camera.zoom -= 0.1;
		} else {
			camera.zoom -= 0.2;
		}
	}
	camera.updateProjectionMatrix();
}

export function onZoomIn(): void {
	if (camera.zoom <= 1) {
		camera.zoom += 0.1;
	} else {
		camera.zoom += 0.2;
	}
	camera.updateProjectionMatrix();
}

export function onRecenter(): void {
	if (isIsoView) {
		camera.position.set(30, 30, 30);
		camera.lookAt(0, 0, 0);
		camera.up.set(0, 0, -1); // X horizontal, Z vertical
	} else {
		camera.position.set(0, 30, 0);
		camera.lookAt(0, 0, 0);
		camera.up.set(0, 1, 0); // X horizontal, Z vertical
	}
}

export function disposeCamera(): void {
	if (isIsoView) {
		switchCameraView()
	}
	camera.position.set(0, 30, 0);
	camera.lookAt(0, 0, 0);
	camera.up.set(0, 0, -1); // X horizontal, Z vertical
}

export { camera, switchCameraView, updateCameraTransition, isIsoView, updateCameraAspect };
